import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import Settings from "./Settings";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("admin-settings")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Settings />
		</ThemeProvider>
	</StrictMode>
);
